/* resources/assets/js/components/pages/statistics/TestStats.vue */
/* resources/assets/js/institution/features/statisticsmanagement/TestResults.vue */

import groupWith from 'ramda/src/groupWith'
import head from 'ramda/src/head'
import { SubCategories } from 'Models'

export default {
    methods: {
        inPerCent(x, from) { return Math.round((100 / from) * x) },
        countQuestions(test) { return test.anzahl_richtig + test.anzahl_falsch },
        percentCorrect(test) {
            if (test.gained_percentage) return parseFloat(test.gained_percentage).toFixed(2)
            const count = this.countQuestions(test)
            return count > 0 ? (test.anzahl_richtig / count * 100).toFixed(2) : 0
        },
        setSubCategories(testAnswers) {
            const groupByMainCatID = groupWith( (a,b) => a.mainCategoryID === b.mainCategoryID )
            const categoryMappings = testAnswers.map( t => ({
                mainCategoryID: t.main_category_id,
                subCategory: SubCategories.create(t.sub_category)
            }))
            const allSubCats = categoryMappings.map( x=>x.subCategory )

            SubCategories.setSelectedOnes( allSubCats )
            SubCategories.setAll( allSubCats )
            groupByMainCatID(categoryMappings).map( group => {
                const mainCatID = head(group).mainCategoryID
                SubCategories.addToLoadedSubCategories(mainCatID, group.map( x=>x.subCategory ))
            })
        },
    },
};

